/**
 * Created by Tomasz Gabrysiak @ Infermedica on 14/02/2017.
 * import * as data from '../../templates/bangla';
 */
const obj = require('json-loader!./bangla.json');
export function replaceNumbers (input) {
  var abc;
  for (var i = 0; i < obj.length; i++) {
    if (obj[i].name === input) {
      abc = obj[i].bangla_name;
    }
  }
  if (!abc) {
    abc = input;
  }
  return abc;
}



// WEBPACK FOOTER //
// ./src/templates/helpers_risk.js